import React, { Component,Fragment } from 'react';
import ReturnPageHeader from "pages/returnCheckout/ReturnPageHeader" 
import shop from "shop/shop"
import Responsive from "react-responsive"
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea} from "semantic-ui-react"
import { Link } from "react-router-dom"
import {
	Card,
	Col,
	FormField,
	FormInput,
	Row,Table
  } from "elemental-react16"
class ReturnPageContactPerson extends Component {
    state = {
        newcust: {
            address: {
                street: "",
                streetnumber: "",
                addition: "",
                postcode: "",
                city: "",
                country: "",
                street1: "",
                addition1: "",
                postcode1: "",
                city1: "",
                country1: "",
                deliverstreet: "",
                deliverstreetnumber: "",
                deliveraddition: "",
                deliverpostcode: "",
                delivercity: "",
                delivercountry: ""
            },
            contact: {
                email: "",
                email1:"",
                email2:"",
                phone: "",
                phone1: "",
                mobile: "",
                contact: "",
                comment: "",
                external: false
            },
            locale: "",
            deliveraddress: {
                streetnumber: "",
                street: "",
                addition: "",
                pcode: "",
                city: "",
                country: "",
                email: "",
                name1: "",
                name2: "",
                zusatz: "",
                phone: "",
                extras: {
                    freecontact: "",
                    addition: ""
                }
            },
            addressConfirmation: {
                streetnumber: "",
                street: "",
                addition: "",
                pcode: "",
                city: "",
                country: "",
                email: "",
                name1: "",
                name2: "",
                zusatz: "",
                phone: "",
                extras: {
                    freecontact: "",
                    addition: ""
                }
            }
        }
    }

    componentDidMount() {
        shop.cart.hooks.changed.add( this.updateCart )
        shop.cart.hydrate()
        shop.cart.update()
        if(!shop.delivery[0]){
          console.log("shop.delivery is empty")
          this.props.history.push("/return")
        }
        if(!shop.delivery){
            console.log("shop.delivery is empty")
            this.props.history.push("/return")
        }
        if (shop.delivery && shop.delivery[0]) {
            this.setState(prevState => ({
                newcust: {
                    ...prevState.newcust,
                    contact: shop.delivery[0].contact
                }
            }));
        }
      }

      handleChange = ( { product } ) => {
        shop.cart.add( product )
      }
      
      updateCart = () => {
        let products = getProducts()
        products = getProducts()
        this.setState( { products } )
        this.forceUpdate()
      }
      
      componentWillUnmount() {
        this.setState({productsTemp: shop.cart.products})
        shop.cart.hooks.changed.remove( this.updateCart )
      }

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        console.log(this.state);
    }

    handleConfirmContact = () => {
        console.log("handleConfirmContact PRE",shop.delivery)
        shop.delivery[0].contact = this.state.newcust.contact
        console.log("handleConfirmContact POST",shop.delivery)
        shop.cart.setExtra( "contact", this.state.newcust.contact.contact )
        shop.cart.setExtra( "comment", this.state.newcust.contact.comment )
        shop.cart.setExtra( "email", this.state.newcust.contact.email )
        shop.cart.setExtra( "phone", this.state.newcust.contact.phone )
        shop.cart.setExtra( "external", this.state.newcust.contact.external )
    }


    handleForward = () => {
        console.log("handleForward RETURN",this.state.newcust.contact)
        shop.cart.setExtra( "contact", this.state.newcust.contact.contact )
        shop.cart.setExtra( "comment", this.state.newcust.contact.comment )
        shop.cart.setExtra( "email", this.state.newcust.contact.email )
        shop.cart.setExtra( "phone", this.state.newcust.contact.phone )
        shop.cart.setExtra( "external", this.state.newcust.contact.external )
        this.props.history.push( "/return/confirmation" )
    }


    render() {

        if(!shop.delivery){
            console.log("shop.delivery is empty")
            this.props.history.push("/return")
            document.location.reload()
            return null
        }


        //console.log("shop.",shop.delivery)
        const handleChange = (event) => {
            //console.log("CHANGE: ", event.target)
            let tempname = event.target.name
            let tempname2 = event.target.className
            let tempvalue = event.target.value
            this.setState(prevState => {
                let newcust = { ...prevState.newcust };  
                newcust[tempname][tempname2] = tempvalue;       
                return { newcust }; 
              })
              this.handleConfirmContact()
          }; 

    
        const handleCommentChange = ( event ) => {
        //console.log("VALUE:",event.target)
        let comment = event.target.value
        this.setState(prevState => {
            let newcust = { ...prevState.newcust };  
            newcust.contact.comment = comment;       
            return { newcust }; 
            })
            this.handleConfirmContact()
        }
        return (
            <Fragment>
                <Responsive minWidth={790}>
                <div>
                <Table>
                <colgroup>
                    <col width="10%" />
                    <col width="12%" />
                    <col width="3%" />
                    <col width="55%" />
                </colgroup>
                <tbody>
                    <tr>
                        <td>
                            &nbsp;
                        </td>
                        <td className="pr4  pl4 v-top ReturnPageAlignment" >
                            <ReturnPageHeader className="v-top" activeStep={1} />
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td className="pr4  pl4 v-top ReturnPageAlignment" >
                            <h1 style={{color:"#265a88", fontSize:40}}  className="pt5 tl"><b>Ansprechpartner</b></h1>
                            <Message style={{width: "80%"}}>
                                <div>{translate( "Bitte tragen Sie Ihre Kontaktdaten ein.")}</div>
                            </Message>
                            <Form style={{width: "80%"}}>
					        <h3>{translate("Erreichbarkeit")}</h3>
                        {/*<Form.Field required>
							<label>{translate("Ansprechpartner")}</label>
							<input value={this.state.newcust.contact.contact} onChange={handleChange} className="contact" name="contact" nameadd="contact" placeholder="Ansprechpartner" />
						</Form.Field>*/}
                        <Form.Group >
						<Form.Input width={14} required label={translate("Ansprechpartner")}><input value={this.state.newcust.contact.contact} onChange={handleChange} className="contact" name="contact" nameadd="contact" placeholder="Ansprechpartner" /></Form.Input>
                        <Form.Checkbox
                            style={{paddingTop: "35px"}}
                            width={2}
                            className="external"
                            checked={this.state.newcust.contact.external}
                            onChange={() => {
                                console.log("EXTERNAL PRE",this.state.newcust.contact)
                                this.setState(prevState => {
                                    let newcust = { ...prevState.newcust };
                                    newcust.contact.external = !newcust.contact.external;
                                    return { newcust };
                                });
                                console.log("EXTERNAL POST",this.state.newcust.contact)
                                this.handleConfirmContact();
                            }}
                            name="external"
                            nameadd="external"
                            label={translate("Extern")}
                        />
                        </Form.Group>
						<Form.Field required>
							<label>{translate("E-Mail")}</label>
							<input value={this.state.newcust.contact.email} onChange={handleChange} className="email" name="contact" nameadd="email" placeholder={translate("E-Mail")} />
						</Form.Field>
						<Form.Group widths="equal">
						<Form.Input required label={translate("Telefon")}><input value={this.state.newcust.contact.phone} onChange={handleChange} required className="phone" name="contact" label="Telefon:" placeholder={translate("Telefon")}  /></Form.Input>
						</Form.Group>
						{/*<FormField label={translate( "comment" )} htmlFor="supported-controls-input">
							   <FormInput placeholder={translate( "Ihr Kommentar..." )} value={this.state.newcust.contact.comment} onChange={handleCommentChange} multiline/>
              			</FormField>*/}
  				</Form>
                        </td>
                    </tr>
                    <tr >
                        <td>
                        &nbsp;
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td>
                            <div style={{paddingTop: "50px",width: "80%"}} className="">
                            <Link to={{
                                pathname: `/return/quantity`,
                                search  : this.props.location.search
                            }}>
                                <Button
                                primary >
                                {translate( "Zurück" )}
                                <i className="icon-angle-right"/>
                                </Button>
                            </Link>
                                <Button
                                    className="fr"
                                    disabled={false}
                                    primary
                                    onClick={this.handleForward}
                                    >{translate( "Kontaktdaten bestätigen" )}</Button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </Table>
            </div>
                </Responsive>
                <Responsive maxWidth={789}>
                <table>
                <colgroup>
                    <col width="90%" />
                </colgroup>
                <tbody>
                    <tr className="bb b--black-10">
                        <td>
                        <div className="headerInline"><Button style={{backgroundColor: "#ffffff", maxWidth:"55px"}} 
                            onClick={() => (this.state.navHeader ? this.setState({navHeader : false}) : this.setState({navHeader : true}
                            ))}>
                                <Icon className="big bars tc" ></Icon>
                            </Button><span className="pt3 tc fw7 f2">Restanten</span></div>
                        {this.state.navHeader && <ReturnPageHeader className="v-top" activeStep={1} />}
                        </td>
                        </tr>
                        <tr>
                        <td className="tc pr2  pl2 v-top ReturnPageAlignment" >
                            <h1 style={{color:"#265a88", fontSize:40}}  className="tc"><b>Ansprechpartner</b></h1>
                            <Message className="tc">
                                <div>{translate( "Bitte tragen Sie Ihre Kontaktdaten ein.")}</div>
                            </Message>
                            <Form className="pl3 pr3">
					        <h3>{translate("Erreichbarkeit")}</h3>
                            {/*<Form.Field required>
							<label>{translate("Ansprechpartner")}</label>
							<input value={this.state.newcust.contact.contact} onChange={handleChange} className="contact" name="contact" nameadd="contact" placeholder="Ansprechpartner" />
						</Form.Field>*/}
                        <Form.Group >
						<Form.Input width={14} required label={translate("Ansprechpartner")}><input value={this.state.newcust.contact.contact} onChange={handleChange} className="contact" name="contact" nameadd="contact" placeholder="Ansprechpartner" /></Form.Input>
                        <Form.Checkbox
                            
                            width={2}
                            className="pt3 pb3 external"
                            checked={this.state.newcust.contact.external}
                            onChange={() => {
                                console.log("EXTERNAL PRE",this.state.newcust.contact)
                                this.setState(prevState => {
                                    let newcust = { ...prevState.newcust };
                                    newcust.contact.external = !newcust.contact.external;
                                    return { newcust };
                                });
                                console.log("EXTERNAL POST",this.state.newcust.contact)
                                this.handleConfirmContact();
                            }}
                            name="external"
                            nameadd="external"
                            label={translate("Extern")}
                        />
                        </Form.Group>
						<Form.Field className="tc" required>
							<label className="tc">{translate("E-Mail")}</label>
							<input value={this.state.newcust.contact.email} onChange={handleChange} className="email" name="contact" nameadd="email" placeholder={translate("E-Mail")} />
						</Form.Field>
						<Form.Group widths="equal">
						<Form.Input required label={translate("Telefon")}><input value={this.state.newcust.contact.phone} onChange={handleChange} required fluid className="phone" name="contact" label="Telefon:" placeholder={translate("Telefon")}  /></Form.Input>
						</Form.Group>
						{/*<FormField label={translate( "comment" )} htmlFor="supported-controls-input">
							   <FormInput placeholder={translate( "Ihr Kommentar..." )} value={this.state.newcust.contact.comment} onChange={handleCommentChange} multiline/>
              			</FormField>*/}
  				</Form>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="tl">
                            <Link to={{
                                pathname: `/return/quantity`,
                                search  : this.props.location.search
                            }}>
                                <Button
                                primary >
                                {translate( "Zurück" )}
                                <i className="icon-angle-right"/>
                                </Button>
                            </Link>
                                <Button
                                    className="fr"
                                    disabled={false}
                                    primary
                                    onClick={this.handleForward}
                                    >{translate( "Kontaktdaten bestätigen" )}</Button>
                            </div>
                        </td>
                    </tr>
                        </tbody>
                        </table>
                </Responsive>
            </Fragment>
        );
    }
}

const getProducts = () => shop.cart.map( ( product ) => product)

export default ReturnPageContactPerson;


// WEBPACK FOOTER //
// ./src/theme/braunsheitmann/pages/returnCheckout/ReturnPageContactPerson.js